import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=082d3637"
import script from "./FlagIcon.vue?vue&type=script&lang=js"
export * from "./FlagIcon.vue?vue&type=script&lang=js"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=082d3637&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports